module.exports = "/_next/static/images/associationLogo3-397ea4f7eaacdbc55a2e6e23eaf18b87.webp";